import React from "react";

export const LazyAccountsPage = React.lazy(() => import("modules/investorRole/pages/AccountsPage"));
